import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { NoDueFormComponent } from '../ELCM/no-due-form/no-due-form.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { formatDate, formatText } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-resign-employee-asset',
  templateUrl: './resign-employee-asset.component.html',
  styleUrls: ['./resign-employee-asset.component.scss'],
})
export class ResignEmployeeAssetComponent implements OnInit {

  @Input() tableDataForResign: any;
  @Input() companyId: any
  @Input() year: any
  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    resizable: true,
  };

  rowData: any[] = [];
  paginationPageSize = 10;
  public rowSelection: 'single' | 'multiple' = 'multiple'; // 👈 bind to template
  loggedInCompanyFiscalyear: any
  loggedInUserName: any;
  loggedInUserRole: any
  formatedataVariable = formatText;
  strFormatDate = formatDate;
  // AG Grid bindings
  columnDefs: ColDef[] = [
    { field: 'empName', headerName: 'Employee Name', sortable: true, filter: true, resizable: true },
    { field: 'resignDate', headerName: 'Resign Date', sortable: true, filter: true },
    { field: 'lwd', headerName: 'LWD', sortable: true, filter: true },
    // { field: 'status', headerName: 'Status', sortable: true, filter: true },
    {
  field: 'status',
  headerName: 'Status',
  sortable: true,
  filter: true,
  cellRenderer: (params: any) => {
    const status = params.value?.toLowerCase();

    // Choose color and label based on status
    const color =
      status === 'cleared'
        ? '#4CAF50' // Green
        : '#F44336'; // Red

    const text = status === 'cleared' ? 'Cleared' : 'Pending';

    // Return styled HTML button
    return `
      <button style="
        background-color: ${color};
        color: white;
        border: none;
        border-radius: 50px;
        padding: 4px 10px;
        cursor: default;
        font-size: 12px;
      ">
        ${text}
      </button>
    `;
  },
},

    {
      field: 'asset',
      headerName: 'Allocated Assets',
      sortable: true,
      filter:false,
      cellRenderer: (params: any) => {
        // ✅ If there's a value, show the Material icon

        if (params.value) {
          return `
        <i class="material-icons" 
           style="cursor:pointer; color:#1976d2; font-size:22px;">
          visibility
        </i>
      `;
        }
        return '';
      }
    }
  ];
  constructor(private httpService: HttpService, private encryptionService: EncryptionService,
    private config: Config, public dialog: MatDialog, public router: Router,
    public mobileResponsiveService: MobileResponsiveService) { }
  ngOnInit() {

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.assetAllocationData();
  }

  originalAssets: any[] = [];
  assetAllocationFromAuthority: any = [];
  assetAllocationlistForEmployee: any = [];
  assets: any = [];
  assetAllocationData() {
    this.httpService.callGetService(`${this.config.assetAllocation}/${this.companyId}/${this.loggedInCompanyFiscalyear}/${this.year}`)
      .subscribe((elm: any) => {

        this.originalAssets = elm.data;


        this.assetAllocationFromAuthority = elm?.data?.filter((record: any) => record.authorityName == this.loggedInUserName);
        this.assetAllocationlistForEmployee = elm.data;
        this.groupAssetsByName();


        // this.groupEmployees();
      })

  }
  groupAssetsByName() {
    const assetMap = new Map<string, any>();

    // ✅ Helper to add assets into the map
    const addToMap = (asset: any) => {
      if (!asset || !asset.assetName) return; // skip invalid entries

      if (assetMap.has(asset.assetName)) {
        const existingAsset = assetMap.get(asset.assetName);
        existingAsset.users.push({
          id: asset.id,
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          assetId: asset.assetId,
          userId: asset.userId,
          employeeName: asset.employeeName,
          employeeComment: asset.employeeComment,
          currentAssetDescription: asset.currentAssetDescription,
          authorityDepartmentComment: this.formatedataVariable(asset.authorityDepartmentComment),
          assetRepairTime: asset.assetRepairTime,
          employeeAssetStatus: this.formatedataVariable(asset.employeeAssetStatus),
          employeeCommentDate: this.strFormatDate(asset.employeeCommentDate),
          dateOfAllocation: this.strFormatDate(asset.dateOfAllocation),
          allocatingAuthorityName: asset.authorityName,
          authorityDepartment: asset.authorityDepartment,
          authorityCommentDate: this.strFormatDate(asset.authorityCommentDate)
        });
      } else {
        assetMap.set(asset.assetName, {
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          isExpand: false,
          users: [{
            id: asset.id,
            assetName: asset.assetName,
            bands: asset.bands,
            band: asset.band,
            userId: asset.userId,
            assetId: asset.assetId,
            employeeName: asset.employeeName,
            employeeComment: asset.employeeComment,
            currentAssetDescription: asset.currentAssetDescription,
            authorityDepartmentComment: this.formatedataVariable(asset.authorityDepartmentComment),
            assetRepairTime: asset.assetRepairTime,
            employeeAssetStatus: this.formatedataVariable(asset.employeeAssetStatus),
            employeeCommentDate: this.strFormatDate(asset.employeeCommentDate),
            dateOfAllocation: this.strFormatDate(asset.dateOfAllocation),
            allocatingAuthorityName: asset.authorityName,
            authorityDepartment: asset.authorityDepartment,
            authorityCommentDate: this.strFormatDate(asset.authorityCommentDate)
          }]
        });
      }
    };



    const isAdmin =
      this.loggedInUserRole === 'HR Admin' ||
      this.loggedInUserRole === 'Super Admin' ||
      this.loggedInUserRole === 'MD' ||
      this.loggedInUserRole === 'PHI Admin';

    // ✅ Logic to decide dataset
    if (isAdmin && this.originalAssets?.length > 0) {
    
      for (const asset of this.originalAssets) addToMap(asset);
    } else if (!isAdmin && this.assetAllocationFromAuthority?.length > 0) {
 
      for (const asset of this.assetAllocationFromAuthority) addToMap(asset);
    } else {
     
      const combined = [...(this.originalAssets || []), ...(this.assetAllocationFromAuthority || [])];
      for (const asset of combined) addToMap(asset);
    }

    // ✅ Convert map to array
    this.assets = Array.from(assetMap.values());
 

    // ✅ Continue with post-processing
    this.manageData();
  }




  manageData() {
    if (this.assets && this.assets.length > 0) {
      // 1️⃣ Flatten all users
      const allUsers = this.assets.flatMap((item: any) => item.users || []);


      // 2️⃣ Group by userId
      const groupedUsers = Object.values(
        allUsers.reduce((acc: any, curr: any) => {
          if (!acc[curr.userId]) {
            acc[curr.userId] = {
              userId: curr.userId,
              employeeName: curr.employeeName,
              allocatingAuthorityName: [],
              dateOfAllocation: [],
              assets: [],
              authorityDepartmentComment: []
            };
          }

          // Push only unique assets
          if (!acc[curr.userId].assets.includes(curr.assetName)) {
            acc[curr.userId].assets.push(curr.assetName);
            acc[curr.userId].dateOfAllocation.push(curr.dateOfAllocation);
            acc[curr.userId].allocatingAuthorityName.push(curr.allocatingAuthorityName);
            acc[curr.userId].authorityDepartmentComment.push(curr.authorityDepartmentComment);
          }

          return acc;
        }, {})
      );

      // 3️⃣ Assign final grouped data to grid source
      this.rowData = groupedUsers;
      this.getExitFormData();

    }
  }


  onCellClicked(event: any) {
    if (event.colDef.field === 'asset') {
     
      this.noDueForm(event.data)
    }
  }

  noDueForm(event: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    // dialogConfig.height = '70%';
    // dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.width = window.innerWidth <= 576 ? '95%' : '80%';
    dialogConfig.panelClass = 'phi-mdc-dialog__container';  // Only set this class once
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      employeeData: event,
      year: this.year,
      companyId: this.companyId


    };

    const dialogRef = this.dialog.open(NoDueFormComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getExitFormData()
      this.assetAllocationData()
    });


  }


  listofFromData: any = []


  getExitFormData() {
    this.httpService
      .callGetService(`${this.config.getExitAllForm}?companyId=${this.companyId}&year=${this.year}`)
      .subscribe((record: any) => {
       

        // 1️⃣ Filter only pending withdrawals
        const filterData = record?.data.filter(
          (e: any) => e.withdrawalAccepted == null || e.withdrawalAccepted == false
        );
     
        let findUserId = this.rowData.map((e: any) => e.userId)
        let finalshowData = filterData.filter((record: any) => findUserId.includes(record.userId))
       

        // 2️⃣ Map to include asset info from this.rowData
        // const finalData = filterData.map((elm: any) => {
        const finalData = finalshowData.map((elm: any) => {
          const match = this.rowData.find((e: any) => e.userId === elm.userId);

          const originalStatuses = match?.authorityDepartmentComment || []; // ✅ get from rowData

          return {
            userId: elm.userId,
            empName: elm?.empName,
            asset: match?.assets,
            lwd: elm.lastWorkingDay,
            resignDate: elm.resignDate,
            empCode: elm?.empCode,
            origenalStatus: originalStatuses, // ✅ set correctly
            allocatingAuthorityName: match?.allocatingAuthorityName,
            dateOfAllocation: match?.dateOfAllocation,
            managerFullName:elm?.managerFullName,
            // ✅ fixed condition
            status:
              originalStatuses?.length > 0 &&
                originalStatuses.every(
                  (item: any) => item?.trim().toLowerCase() === 'received after exit'
                )
                ? 'Cleared'
                : 'Pending',


          };
        });


        this.listofFromData = finalData;
      });
  }
  gridApi: any;
  searchTaskString: string = '';
  isClicked = false;

  resetGrid() {
    this.isClicked = false; // Trigger animation
  
    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();
  
      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text
  
      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();
  
      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    // params.api.sizeColumnsToFit();
    console.log(params)
  }


}
